import React, { useState, useEffect } from "react";
import BreadCrumb from "../BreadCrumb";
import Layout from "../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../common/Loader";
import DynamicFilters from '../DynamicFilters'
import InfiniteScroll from "react-infinite-scroll-component";
import { customFormatOptions, getReqValue } from "../../common/constants";
import { ADMIN_REPORTS_DATA, downloadReportAction ,getReportsAction, resetReportData } from "../../redux/actions/reportAction";
import DataTable from "../Tables/DataTable";
import { Badge, Button } from "react-bootstrap";
import moment from "moment";
import AgGridTable from "../Tables/agGridTable";

const ReportsList = (props) => {
    const { loader , reportData,pagination } = useSelector((state) => state.report);
    console.log(reportData)
      
  const dispatch = useDispatch();
  const [sideMenu, setSideMenu] = useState(true);
  const [filterLoader, setFilterLoader] = useState(false);
  const [branch, setBranch] = useState([]);
  const [classGroup, setClassGroup] = useState([]);
  const [classRoom, setClassRoom] = useState([]);
  const [year, setYear] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [agGridRef, setAgGridRef] = useState(null);
  const [rowNode, setRowNode] = useState(null);
  const [customRange, setCustomRange] = useState({
    startDate: moment().startOf('year'),
    endDate: moment()
  });
  
  const onSideMenu = (value) => {
    setSideMenu(value);
  };
  useEffect(() => {
    dispatch(resetReportData())
  }, [])
  const headerList = [
    {
      name: "Enrollment No",
      key: "RegNo",
    },
    {
      name: "Name",
      key: "Name",
    },
    // { name: "Gender", key: "gender" },
    {
      name: "Email",
      key: "Email",
    },

    {
      name: "Guardians",
      key: "Guardians",
      requiredActions: [
        {
          name: "Father",
          dataKey: "Father Name",
        },
        {
          name: "Father",
          dataKey: "Father Mobile Number",
        },
        {
          name: "Mother",
          dataKey: "Mother Name",
        },
        {
          name: "Mother",
          dataKey: "Mother Mobile Number",
        },
      ],
    },
    { name: "Class Group", key: "Class Group Name" },
    { name: "Class", key: "Class Room Name" },
    { name: "Due Amount", key: "dueAmount" }
  ];
  const columnDefs = [
    {
      headerName: "Enrollment No",
      field: "RegNo",
      // maxWidth:150
    },
    {
      headerName: "Name",
      field: "Name",
    },
    {
      headerName: "Email",
      field: "Email",
    },

    {
      headerName: "Mother Mobile Number",
      field: "Mother Mobile Number"
    },
    {
      headerName: "Father Mobile Number",
      field: "Father Mobile Number"
    },
    { headerName: "Class Group", field: "Class Group Name",maxWidth:150 },
    { headerName: "Class Room", field: "Class Room Name",maxWidth:150 },
    { headerName: "Due Amount", field: "dueAmount" }
  ];

  const nestedHeaders = [
    "",
    "",
    "",
    "Name",
    "Phone Number ",
    "Name",
    "Phone Number",
    "",
    "",
    "",
  ];
  const DynamicFiltersProps = [
    {
      type: "Select",
      placeholder: "Select Year",
      state: year,
      mappingKey: "year",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2",
      label: "Year",
    },
    {
      type: "Select",
      placeholder: "Select Branch",
      state: branch,
      mappingKey: "branch",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2",
      label: "Branch",
    },
    {
      type: "Select",
      placeholder: "Select ClassGroup",
      state: classGroup,
      mappingKey: "classGroup",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2",
      label: "Class Group",
    },
    {
      type: "Select",
      placeholder: "Select ClassRoom",
      state: classRoom,
      mappingKey: "classRoom",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "ClassRoom",
    },
    {
      type: "DateRangePicker",
      placeholder: "Select Date Range",
      state: customRange,
      mappingKey: "customDate",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "Select Date Range",
      disabled: year.length === 0
    },
     
  ];

  const DynamicFiltersOptions = {
    branchOptions: [],
    classGroupOptions: [],
    classRoomOptions: [],
    yearOptions: []
  };

  const hierarchyLevel = ["branch", "classGroup", "classRoom"];
  const hierarchyApiCalls = [
    {
      optionsMappingKey: "branch",
      UrlName: "branch"
    },{
      optionsMappingKey: "year",
      UrlName: "year"
    }
  ];
  const hierarchyFilterApi = "branchFilter";
  const onRefresh = () => {
    reloadData();
    dispatch(resetReportData())
  };
  const reloadData = () => {
    setBranch([])
    setClassGroup([])
    setClassRoom([])
    setYear([])
  };
  const updateState = params => {
    let keysLength = Object.keys(params).length;
    if(params.hasOwnProperty("branch")){
        setBranch(params[`branch`])
    }
    if(params.hasOwnProperty("classGroup")){
        setClassGroup(params[`classGroup`])
    }
    if(params.hasOwnProperty("classRoom")){
        setClassRoom(params[`classRoom`])
    }
    if (params.hasOwnProperty("year")) {
      setYear(params[`year`]);
      setCustomRange({
        startDate: moment([params['year'][0].value]).startOf('year'),
        endDate: moment([params['year'][0].value]).endOf('year')
      })
    }
    if (params.hasOwnProperty("customRange")) {
      setCustomRange(params[`customRange`]);
    }
  };
  const fetchParamsList = async()=>{
    const params = {
      BranchId: getReqValue(branch),
      ClassGroupId: getReqValue(classGroup),
      ClassRoomId: getReqValue(classRoom),
      year: getReqValue(year),
      startDate: moment(customRange.startDate).format("YYYY-MM-DD"),
      endDate: moment(customRange.endDate).format("YYYY-MM-DD"),
      page:1,
      perPage: pagination.perPage
    }
    return params;
  }
  const getReportsList = async(params)=>{
    await dispatch(getReportsAction(params))

  }
  const filterData = async() => {
    await dispatch(resetReportData());
    const reqParams = await fetchParamsList();
    await getReportsList(reqParams);
  }
  const openLoader = ()=>{
    setFilterLoader(true);
  }
  const closeLoader = ()=>{
    setFilterLoader(false);
  }
  const downloadReports = async() => {
    const params = {
      BranchId: getReqValue(branch),
      ClassGroupId: getReqValue(classGroup),
      ClassRoomId: getReqValue(classRoom),
      year: getReqValue(year),
      startDate: moment(customRange.startDate).format("YYYY-MM-DD"),
      endDate: moment(customRange.endDate).format("YYYY-MM-DD")
    }
    await dispatch(downloadReportAction(params))

  }
  const fetchMoreData =async()=>{
    // if (studentProfiles.length === pagination.totalItems) {
    if ((pagination.totalPages === 1 || (pagination.totalPages -1) === pagination.currentPage)  ) {
      setHasMore(false)
      return;
    }
    let reqParams = await fetchParamsList();
    reqParams.page = ( pagination.currentPage + 1);
  
    await getReportsList(reqParams)
  }
  const setGridRefData =(params)=>{
    setAgGridRef(params)
  }

  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader || filterLoader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <div className="spacer"></div>
          <div class="row filter-block">
              <DynamicFilters
                filtersList={DynamicFiltersProps}
                options={DynamicFiltersOptions}
                hierarchyLevel={hierarchyLevel}
                hierarchyApiCalls={hierarchyApiCalls}
                hierarchyFilterApi={hierarchyFilterApi}
                openLoader={openLoader}
                closeLoader={closeLoader}
                updateParentState={updateState}
                filterData={filterData}
                onReset={onRefresh}
                // onDatepickerChange={this.handleYearData}
                viewType="verticle"
                isFilterButtonDisabled={branch.length === 0 || year.length === 0 }
              />
            </div>
            <div className="row">
            <div className="col-2">
                  <Button
                      className="btn  app-default-button btn-sm"
                    >
                      Total Students <Badge variant="primary">{pagination.totalItems}</Badge>
                    </Button>
                    
                  </div>
                  <div className="col-8">
                  </div>
                <div className="col-2 text-right">
                <Button
                      className="btn  app-default-button btn-sm"
                      disabled={reportData.totalStudents.length === 0}
                      onClick={downloadReports}
                    >
                      <i className="fa fa-download"></i> 
                    </Button>
                  </div>
            </div>
            <div className="spacer"></div>
            {reportData.totalStudents.length > 0 ? (
              <>
              {/* <InfiniteScroll
                  dataLength={reportData.totalStudents.length}
                  next={fetchMoreData}
                  hasMore={pagination.totalPages === 1 ? false : hasMore}
                  loader={<h4>Loading...</h4>}
                  endMessage={
                    <div className="alert alert-success text-center">
                      Yay! You have seen it all
                    </div>
                  }
                >
                    <DataTable
                  header={headerList}
                  data={reportData.totalStudents}
                  nestedHeader={nestedHeaders}
                />
              </InfiniteScroll> */}
              <AgGridTable 
            rowData={reportData.totalStudents} 
            columnDefs={columnDefs} 
            defaultColDef={{
              resizable: true,minWidth: 100}}
            pagination={pagination}
            isPaginationRequired={true}
            actionType={ADMIN_REPORTS_DATA}
            fetchParamsList={fetchParamsList}
            setAgGridRef={setGridRefData}
              />
              </>
            
          ) : (
            <div className="alert alert-success">No Data to view</div>
          )}
        </div>
      </PageLoader>
    </div>
  );
};

export default ReportsList;
